var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 14.578 14.578 0 16 1.422 1.422 16z","key":0}),React.createElement("path",{"fill":"#fff","d":"M16 14.578 1.422 0 0 1.422 14.578 16z","key":1})]);
}

Close.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = Close;

Close.default = Close;
